module.exports = __webpack_public_path__ + "img/logo_oblab.f2c8cad1.jpg";